module.exports = __webpack_public_path__ + "img/photo-album-bg.38bda38c.png";